// Homepage / FAQ page questions (EN/FR/DE). Genuinely useful answers.

export const FAQS = [
  {
    q: {
      en: "Is dental treatment in Vietnam safe?",
      fr: "Les soins dentaires au Vietnam sont-ils sûrs ?",
      de: "Ist eine Zahnbehandlung in Vietnam sicher?",
    },
    a: {
      en: "Safety depends on the individual clinic rather than the country. Look for a licensed clinic, qualified dentists, clear sterilisation procedures, recognised materials and a written treatment plan. Our provider checklist can help you ask the right questions.",
      fr: "La sécurité dépend de la clinique, pas du pays. Recherchez une clinique agréée, des dentistes qualifiés, des procédures de stérilisation claires, des matériaux reconnus et un plan de traitement écrit. Notre check-list peut vous aider à poser les bonnes questions.",
      de: "Die Sicherheit hängt von der jeweiligen Klinik ab, nicht vom Land. Achten Sie auf eine lizenzierte Klinik, qualifizierte Zahnärzte, klare Sterilisationsverfahren, anerkannte Materialien und einen schriftlichen Behandlungsplan. Unsere Checkliste hilft Ihnen dabei.",
    },
  },
  {
    q: {
      en: "How much does dental treatment cost in Vietnam?",
      fr: "Combien coûtent les soins dentaires au Vietnam ?",
      de: "Wie viel kostet eine Zahnbehandlung in Vietnam?",
    },
    a: {
      en: "Costs vary widely depending on the treatment, materials, the clinic and the complexity of your case. We do not publish fixed prices to avoid misleading estimates. Send your details for indicative information tailored to your situation.",
      fr: "Les coûts varient fortement selon le traitement, les matériaux, la clinique et la complexité du cas. Nous ne publions pas de prix fixes afin d’éviter les estimations trompeuses. Envoyez vos informations pour une estimation indicative.",
      de: "Die Kosten variieren stark je nach Behandlung, Materialien, Klinik und Komplexität. Wir veröffentlichen keine festen Preise, um irreführende Schätzungen zu vermeiden. Senden Sie Ihre Angaben für Richtinformationen.",
    },
  },
  {
    q: {
      en: "Are dental implants cheaper in Vietnam?",
      fr: "Les implants dentaires sont-ils moins chers au Vietnam ?",
      de: "Sind Zahnimplantate in Vietnam günstiger?",
    },
    a: {
      en: "Treatment costs in Vietnam may be lower than in some countries, but this varies by clinic, implant brand and your specific case. Compare like-for-like: the implant system, materials, warranty and aftercare all matter, not just the headline price.",
      fr: "Les coûts au Vietnam peuvent être inférieurs à ceux de certains pays, mais cela varie selon la clinique, la marque d’implant et votre cas. Comparez à prestations égales : système d’implant, matériaux, garantie et suivi comptent autant que le prix affiché.",
      de: "Die Kosten in Vietnam können niedriger sein als in einigen Ländern, das variiert jedoch je nach Klinik, Implantatmarke und Fall. Vergleichen Sie Gleiches mit Gleichem: Implantatsystem, Materialien, Garantie und Nachsorge zählen, nicht nur der Preis.",
    },
  },
  {
    q: {
      en: "How long should I stay in Vietnam?",
      fr: "Combien de temps dois-je rester au Vietnam ?",
      de: "Wie lange sollte ich in Vietnam bleiben?",
    },
    a: {
      en: "This depends entirely on your treatment. Some treatments are completed in a few days, while implants often need a healing period and may require more than one trip. Your provider will outline the timeline before you travel.",
      fr: "Cela dépend entièrement de votre traitement. Certains soins se font en quelques jours, tandis que les implants nécessitent souvent une cicatrisation et parfois plusieurs voyages. Votre prestataire précisera le calendrier avant votre départ.",
      de: "Das hängt ganz von Ihrer Behandlung ab. Manche Behandlungen sind in wenigen Tagen erledigt, während Implantate oft eine Einheilphase und mehrere Reisen erfordern. Ihr Anbieter erläutert den Zeitplan vor der Reise.",
    },
  },
  {
    q: {
      en: "Can I get All-on-4 dental implants in Vietnam?",
      fr: "Puis-je obtenir des implants All-on-4 au Vietnam ?",
      de: "Kann ich All-on-4 Implantate in Vietnam bekommen?",
    },
    a: {
      en: "Some selected providers in Vietnam offer full-arch implant solutions such as All-on-4. Availability, implant systems and experience vary by clinic, so confirm the details directly with the provider before travelling.",
      fr: "Certains prestataires sélectionnés au Vietnam proposent des solutions d’arcade complète comme l’All-on-4. La disponibilité, les systèmes et l’expérience varient ; confirmez directement avant de voyager.",
      de: "Einige ausgewählte Anbieter in Vietnam bieten Vollbogen-Lösungen wie All-on-4 an. Verfügbarkeit, Systeme und Erfahrung variieren; bitte vor der Reise direkt bestätigen.",
    },
  },
  {
    q: {
      en: "Do dentists in Vietnam speak English?",
      fr: "Les dentistes au Vietnam parlent-ils anglais ?",
      de: "Sprechen Zahnärzte in Vietnam Englisch?",
    },
    a: {
      en: "Some clinics — particularly those used to international patients — offer English-speaking dentists or support staff. This varies by provider. We can help you understand which selected providers offer international patient support.",
      fr: "Certaines cliniques — surtout celles habituées aux patients internationaux — proposent des dentistes ou un personnel anglophone. Cela varie selon le prestataire. Nous pouvons vous aider à identifier ceux offrant un accompagnement international.",
      de: "Manche Kliniken — besonders solche mit internationalen Patienten — bieten englischsprachige Zahnärzte oder Personal. Das variiert je nach Anbieter. Wir helfen Ihnen zu verstehen, welche ausgewählten Anbieter internationale Betreuung bieten.",
    },
  },
  {
    q: {
      en: "What information should I send before travelling?",
      fr: "Quelles informations dois-je envoyer avant de voyager ?",
      de: "Welche Informationen sollte ich vor der Reise senden?",
    },
    a: {
      en: "Helpful information includes recent dental photos, any X-rays or scans you have, a description of your concerns and your treatment goals. This allows an initial, informal review — it is not a diagnosis, which requires an in-person examination.",
      fr: "Les informations utiles incluent des photos dentaires récentes, vos radiographies ou scans, une description de vos préoccupations et vos objectifs. Cela permet une première évaluation informelle — ce n’est pas un diagnostic, qui nécessite un examen en personne.",
      de: "Hilfreich sind aktuelle Zahnfotos, vorhandene Röntgenbilder oder Scans, eine Beschreibung Ihrer Anliegen und Ihre Ziele. Das ermöglicht eine erste, informelle Prüfung — keine Diagnose, die eine persönliche Untersuchung erfordert.",
    },
  },
  {
    q: {
      en: "Can I get an online dental consultation?",
      fr: "Puis-je obtenir une consultation dentaire en ligne ?",
      de: "Kann ich eine Online-Zahnberatung erhalten?",
    },
    a: {
      en: "You can send your details and photos for an initial, informal review to help you understand possible options. A formal diagnosis and treatment recommendation always require an in-person examination by a licensed dentist.",
      fr: "Vous pouvez envoyer vos informations et photos pour une première évaluation informelle afin de comprendre les options possibles. Un diagnostic formel et une recommandation nécessitent toujours un examen en personne par un dentiste agréé.",
      de: "Sie können Angaben und Fotos für eine erste, informelle Prüfung senden, um mögliche Optionen zu verstehen. Eine förmliche Diagnose und Empfehlung erfordern stets eine persönliche Untersuchung durch einen lizenzierten Zahnarzt.",
    },
  },
  {
    q: {
      en: "What happens if I need aftercare?",
      fr: "Que se passe-t-il si j’ai besoin d’un suivi ?",
      de: "Was passiert, wenn ich Nachsorge brauche?",
    },
    a: {
      en: "Ask your provider about their aftercare and warranty terms before treatment. Understand what is covered, how follow-up works if you are back home, and who to contact if you have questions after you return.",
      fr: "Demandez à votre prestataire ses conditions de suivi et de garantie avant le traitement. Comprenez ce qui est couvert, comment fonctionne le suivi une fois rentré et qui contacter en cas de question.",
      de: "Fragen Sie Ihren Anbieter vor der Behandlung nach Nachsorge- und Garantiebedingungen. Klären Sie, was abgedeckt ist, wie die Nachbetreuung von zu Hause funktioniert und wen Sie bei Fragen kontaktieren.",
    },
  },
  {
    q: {
      en: "Which Vietnamese city is best for dental treatment?",
      fr: "Quelle ville vietnamienne est la meilleure pour les soins dentaires ?",
      de: "Welche vietnamesische Stadt ist am besten für Zahnbehandlungen?",
    },
    a: {
      en: "There is no single best city — it depends on your treatment, travel plans and the specific clinic. Ho Chi Minh City, Da Nang and Hanoi are the destinations international patients most often consider. Each has its own guide on our site.",
      fr: "Il n’existe pas de meilleure ville unique — cela dépend de votre traitement, de votre voyage et de la clinique. Hô Chi Minh-Ville, Da Nang et Hanoï sont les destinations les plus souvent envisagées. Chacune a son guide sur notre site.",
      de: "Es gibt nicht die eine beste Stadt — es hängt von Behandlung, Reiseplänen und Klinik ab. Ho-Chi-Minh-Stadt, Da Nang und Hanoi werden am häufigsten in Betracht gezogen. Jede hat einen eigenen Ratgeber auf unserer Seite.",
    },
  },
];
